import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const ChartInfoModal = ({
  isShow,
  hide,
}: {
  isShow: boolean;
  hide: () => void;
}) => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div className="font-bold text-bluegray-700 text-lg">
              チャートについて
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="text-sm mt-3">
            株式分割や配当により株価が修正されるとチャート上の株価も修正されますが、売買を行なったことを記すアイコン
            <span style={{ color: '#FAB721' }}>▲</span>
            <span style={{ color: '#8052F5' }}>▼</span>
            は、約定単価の修正を行わないため変更されません。
          </div>
          <button
            className="mt-2 p-2 text-bluegray-500 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
